export default "__VITE_ASSET__BKtOZAXV__"